"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.10
//   protoc               v6.33.5
// source: protos/charging-session-attempt.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChargingSession = exports.ChargingSessionAttempt = exports.MembershipTransaction = exports.PaymentTransaction = exports.ChargingTransactionDetails = exports.ChargingTransaction = exports.paymentTerminalControlPaymentPresentedMethodToJSON = exports.paymentTerminalControlPaymentPresentedMethodFromJSON = exports.PaymentTerminalControlPaymentPresentedMethod = exports.powerQualityIssueToJSON = exports.powerQualityIssueFromJSON = exports.PowerQualityIssue = exports.chargerFaultCategoryToJSON = exports.chargerFaultCategoryFromJSON = exports.ChargerFaultCategory = exports.paymentStateToJSON = exports.paymentStateFromJSON = exports.PaymentState = exports.membershipActionCodeToJSON = exports.membershipActionCodeFromJSON = exports.MembershipActionCode = exports.membershipValidationErrorToJSON = exports.membershipValidationErrorFromJSON = exports.MembershipValidationError = exports.chargerPortStateToJSON = exports.chargerPortStateFromJSON = exports.ChargerPortState = exports.chargingSessionMatchingPatternToJSON = exports.chargingSessionMatchingPatternFromJSON = exports.ChargingSessionMatchingPattern = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
const duration_1 = require("../google/protobuf/duration");
const timestamp_1 = require("../google/protobuf/timestamp");
const money_1 = require("./money");
exports.protobufPackage = "charging_session_attempt";
/** The pattern used to match transactions together into a charging session. */
var ChargingSessionMatchingPattern;
(function (ChargingSessionMatchingPattern) {
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN"] = 0] = "CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN";
    /** MEMBERSHIP_TOKEN - Matched by membership token/card. */
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["MEMBERSHIP_TOKEN"] = 1] = "MEMBERSHIP_TOKEN";
    /** PAYMENT_TOKEN - Matched by payment token/card. */
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["PAYMENT_TOKEN"] = 2] = "PAYMENT_TOKEN";
    /** UNIQUE_EVCC_ID - Matched by unique EVCC (Electric Vehicle Communication Controller) ID. */
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["UNIQUE_EVCC_ID"] = 3] = "UNIQUE_EVCC_ID";
    /** PLUG_IN_TIME_PROXIMITY - Matched by proximity in time of plug-in events. */
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["PLUG_IN_TIME_PROXIMITY"] = 4] = "PLUG_IN_TIME_PROXIMITY";
    /** LEGACY_TRANSACTION - Legacy transaction matching for backwards compatibility. */
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["LEGACY_TRANSACTION"] = 5] = "LEGACY_TRANSACTION";
    ChargingSessionMatchingPattern[ChargingSessionMatchingPattern["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChargingSessionMatchingPattern = exports.ChargingSessionMatchingPattern || (exports.ChargingSessionMatchingPattern = {}));
function chargingSessionMatchingPatternFromJSON(object) {
    switch (object) {
        case 0:
        case "CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN":
            return ChargingSessionMatchingPattern.CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN;
        case 1:
        case "MEMBERSHIP_TOKEN":
            return ChargingSessionMatchingPattern.MEMBERSHIP_TOKEN;
        case 2:
        case "PAYMENT_TOKEN":
            return ChargingSessionMatchingPattern.PAYMENT_TOKEN;
        case 3:
        case "UNIQUE_EVCC_ID":
            return ChargingSessionMatchingPattern.UNIQUE_EVCC_ID;
        case 4:
        case "PLUG_IN_TIME_PROXIMITY":
            return ChargingSessionMatchingPattern.PLUG_IN_TIME_PROXIMITY;
        case 5:
        case "LEGACY_TRANSACTION":
            return ChargingSessionMatchingPattern.LEGACY_TRANSACTION;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChargingSessionMatchingPattern.UNRECOGNIZED;
    }
}
exports.chargingSessionMatchingPatternFromJSON = chargingSessionMatchingPatternFromJSON;
function chargingSessionMatchingPatternToJSON(object) {
    switch (object) {
        case ChargingSessionMatchingPattern.CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN:
            return "CHARGING_SESSION_MATCHING_PATTERN_UNKNOWN";
        case ChargingSessionMatchingPattern.MEMBERSHIP_TOKEN:
            return "MEMBERSHIP_TOKEN";
        case ChargingSessionMatchingPattern.PAYMENT_TOKEN:
            return "PAYMENT_TOKEN";
        case ChargingSessionMatchingPattern.UNIQUE_EVCC_ID:
            return "UNIQUE_EVCC_ID";
        case ChargingSessionMatchingPattern.PLUG_IN_TIME_PROXIMITY:
            return "PLUG_IN_TIME_PROXIMITY";
        case ChargingSessionMatchingPattern.LEGACY_TRANSACTION:
            return "LEGACY_TRANSACTION";
        case ChargingSessionMatchingPattern.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.chargingSessionMatchingPatternToJSON = chargingSessionMatchingPatternToJSON;
/** The current state of a charger port. */
var ChargerPortState;
(function (ChargerPortState) {
    ChargerPortState[ChargerPortState["CHARGER_PORT_STATE_UNKNOWN"] = 0] = "CHARGER_PORT_STATE_UNKNOWN";
    /** AVAILABLE - Port is available for charging. */
    ChargerPortState[ChargerPortState["AVAILABLE"] = 1] = "AVAILABLE";
    /** PLUGGED_IN_WAITING_FOR_PAYMENT - A driver has plugged in, but payment hasn't necessarily been authorized yet. */
    ChargerPortState[ChargerPortState["PLUGGED_IN_WAITING_FOR_PAYMENT"] = 2] = "PLUGGED_IN_WAITING_FOR_PAYMENT";
    /** PREPARING - This covers the time before charging has started. */
    ChargerPortState[ChargerPortState["PREPARING"] = 3] = "PREPARING";
    /** CHARGING - Port is actively charging a vehicle. */
    ChargerPortState[ChargerPortState["CHARGING"] = 4] = "CHARGING";
    /** FINISHED - Finished is when a charging session has completed, but a driver hasn't unplugged yet. */
    ChargerPortState[ChargerPortState["FINISHED"] = 5] = "FINISHED";
    /** SETTING_UP_NEXT_SESSION - Setting up next session is for the time between when a driver unplugs, and when we are ready to accept the next session. */
    ChargerPortState[ChargerPortState["SETTING_UP_NEXT_SESSION"] = 6] = "SETTING_UP_NEXT_SESSION";
    /** FAULTED - Port is in a faulted state. */
    ChargerPortState[ChargerPortState["FAULTED"] = 7] = "FAULTED";
    /** UNAVAILABLE - Port is unavailable for use. */
    ChargerPortState[ChargerPortState["UNAVAILABLE"] = 8] = "UNAVAILABLE";
    ChargerPortState[ChargerPortState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChargerPortState = exports.ChargerPortState || (exports.ChargerPortState = {}));
function chargerPortStateFromJSON(object) {
    switch (object) {
        case 0:
        case "CHARGER_PORT_STATE_UNKNOWN":
            return ChargerPortState.CHARGER_PORT_STATE_UNKNOWN;
        case 1:
        case "AVAILABLE":
            return ChargerPortState.AVAILABLE;
        case 2:
        case "PLUGGED_IN_WAITING_FOR_PAYMENT":
            return ChargerPortState.PLUGGED_IN_WAITING_FOR_PAYMENT;
        case 3:
        case "PREPARING":
            return ChargerPortState.PREPARING;
        case 4:
        case "CHARGING":
            return ChargerPortState.CHARGING;
        case 5:
        case "FINISHED":
            return ChargerPortState.FINISHED;
        case 6:
        case "SETTING_UP_NEXT_SESSION":
            return ChargerPortState.SETTING_UP_NEXT_SESSION;
        case 7:
        case "FAULTED":
            return ChargerPortState.FAULTED;
        case 8:
        case "UNAVAILABLE":
            return ChargerPortState.UNAVAILABLE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChargerPortState.UNRECOGNIZED;
    }
}
exports.chargerPortStateFromJSON = chargerPortStateFromJSON;
function chargerPortStateToJSON(object) {
    switch (object) {
        case ChargerPortState.CHARGER_PORT_STATE_UNKNOWN:
            return "CHARGER_PORT_STATE_UNKNOWN";
        case ChargerPortState.AVAILABLE:
            return "AVAILABLE";
        case ChargerPortState.PLUGGED_IN_WAITING_FOR_PAYMENT:
            return "PLUGGED_IN_WAITING_FOR_PAYMENT";
        case ChargerPortState.PREPARING:
            return "PREPARING";
        case ChargerPortState.CHARGING:
            return "CHARGING";
        case ChargerPortState.FINISHED:
            return "FINISHED";
        case ChargerPortState.SETTING_UP_NEXT_SESSION:
            return "SETTING_UP_NEXT_SESSION";
        case ChargerPortState.FAULTED:
            return "FAULTED";
        case ChargerPortState.UNAVAILABLE:
            return "UNAVAILABLE";
        case ChargerPortState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.chargerPortStateToJSON = chargerPortStateToJSON;
/** Errors that can occur during membership validation. */
var MembershipValidationError;
(function (MembershipValidationError) {
    MembershipValidationError[MembershipValidationError["MEMBERSHIP_VALIDATION_ERROR_UNKNOWN"] = 0] = "MEMBERSHIP_VALIDATION_ERROR_UNKNOWN";
    /** INVALID - The membership card or token is invalid. */
    MembershipValidationError[MembershipValidationError["INVALID"] = 1] = "INVALID";
    /** NOT_FOUND - The membership was not found in the system. */
    MembershipValidationError[MembershipValidationError["NOT_FOUND"] = 2] = "NOT_FOUND";
    MembershipValidationError[MembershipValidationError["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MembershipValidationError = exports.MembershipValidationError || (exports.MembershipValidationError = {}));
function membershipValidationErrorFromJSON(object) {
    switch (object) {
        case 0:
        case "MEMBERSHIP_VALIDATION_ERROR_UNKNOWN":
            return MembershipValidationError.MEMBERSHIP_VALIDATION_ERROR_UNKNOWN;
        case 1:
        case "INVALID":
            return MembershipValidationError.INVALID;
        case 2:
        case "NOT_FOUND":
            return MembershipValidationError.NOT_FOUND;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MembershipValidationError.UNRECOGNIZED;
    }
}
exports.membershipValidationErrorFromJSON = membershipValidationErrorFromJSON;
function membershipValidationErrorToJSON(object) {
    switch (object) {
        case MembershipValidationError.MEMBERSHIP_VALIDATION_ERROR_UNKNOWN:
            return "MEMBERSHIP_VALIDATION_ERROR_UNKNOWN";
        case MembershipValidationError.INVALID:
            return "INVALID";
        case MembershipValidationError.NOT_FOUND:
            return "NOT_FOUND";
        case MembershipValidationError.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.membershipValidationErrorToJSON = membershipValidationErrorToJSON;
/** The generic outcome of a membership validation, independent of which membership provider was used. */
var MembershipActionCode;
(function (MembershipActionCode) {
    MembershipActionCode[MembershipActionCode["MEMBERSHIP_ACTION_CODE_UNKNOWN"] = 0] = "MEMBERSHIP_ACTION_CODE_UNKNOWN";
    /** MEMBERSHIP_ACTION_CODE_PROCEED - Member is valid; proceed with the transaction with no special messaging. */
    MembershipActionCode[MembershipActionCode["MEMBERSHIP_ACTION_CODE_PROCEED"] = 1] = "MEMBERSHIP_ACTION_CODE_PROCEED";
    /** MEMBERSHIP_ACTION_CODE_INFORM - Member has a recoverable issue; show an inform/soft-block message but allow the transaction to continue. */
    MembershipActionCode[MembershipActionCode["MEMBERSHIP_ACTION_CODE_INFORM"] = 2] = "MEMBERSHIP_ACTION_CODE_INFORM";
    /** MEMBERSHIP_ACTION_CODE_BLOCK - Member is not valid for use; block the transaction (hard block). */
    MembershipActionCode[MembershipActionCode["MEMBERSHIP_ACTION_CODE_BLOCK"] = 3] = "MEMBERSHIP_ACTION_CODE_BLOCK";
    MembershipActionCode[MembershipActionCode["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(MembershipActionCode = exports.MembershipActionCode || (exports.MembershipActionCode = {}));
function membershipActionCodeFromJSON(object) {
    switch (object) {
        case 0:
        case "MEMBERSHIP_ACTION_CODE_UNKNOWN":
            return MembershipActionCode.MEMBERSHIP_ACTION_CODE_UNKNOWN;
        case 1:
        case "MEMBERSHIP_ACTION_CODE_PROCEED":
            return MembershipActionCode.MEMBERSHIP_ACTION_CODE_PROCEED;
        case 2:
        case "MEMBERSHIP_ACTION_CODE_INFORM":
            return MembershipActionCode.MEMBERSHIP_ACTION_CODE_INFORM;
        case 3:
        case "MEMBERSHIP_ACTION_CODE_BLOCK":
            return MembershipActionCode.MEMBERSHIP_ACTION_CODE_BLOCK;
        case -1:
        case "UNRECOGNIZED":
        default:
            return MembershipActionCode.UNRECOGNIZED;
    }
}
exports.membershipActionCodeFromJSON = membershipActionCodeFromJSON;
function membershipActionCodeToJSON(object) {
    switch (object) {
        case MembershipActionCode.MEMBERSHIP_ACTION_CODE_UNKNOWN:
            return "MEMBERSHIP_ACTION_CODE_UNKNOWN";
        case MembershipActionCode.MEMBERSHIP_ACTION_CODE_PROCEED:
            return "MEMBERSHIP_ACTION_CODE_PROCEED";
        case MembershipActionCode.MEMBERSHIP_ACTION_CODE_INFORM:
            return "MEMBERSHIP_ACTION_CODE_INFORM";
        case MembershipActionCode.MEMBERSHIP_ACTION_CODE_BLOCK:
            return "MEMBERSHIP_ACTION_CODE_BLOCK";
        case MembershipActionCode.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.membershipActionCodeToJSON = membershipActionCodeToJSON;
/** The current state of a payment transaction. */
var PaymentState;
(function (PaymentState) {
    PaymentState[PaymentState["PAYMENT_STATE_UNKNOWN"] = 0] = "PAYMENT_STATE_UNKNOWN";
    /** PRESENTED - Payment method has been presented but not yet processed. */
    PaymentState[PaymentState["PRESENTED"] = 1] = "PRESENTED";
    /** AUTHORIZING - Payment is currently being authorized. */
    PaymentState[PaymentState["AUTHORIZING"] = 2] = "AUTHORIZING";
    /** AUTHORIZED - Payment has been successfully authorized. */
    PaymentState[PaymentState["AUTHORIZED"] = 3] = "AUTHORIZED";
    /** EXPIRED - Payment authorization has expired. */
    PaymentState[PaymentState["EXPIRED"] = 4] = "EXPIRED";
    /** CANCELLED - Payment has been cancelled. */
    PaymentState[PaymentState["CANCELLED"] = 5] = "CANCELLED";
    /** PENDING_CAPTURE - Payment is pending capture after successful authorization. */
    PaymentState[PaymentState["PENDING_CAPTURE"] = 6] = "PENDING_CAPTURE";
    /** CAPTURING - Payment is currently being captured. */
    PaymentState[PaymentState["CAPTURING"] = 7] = "CAPTURING";
    /** CAPTURED - Payment has been successfully captured. */
    PaymentState[PaymentState["CAPTURED"] = 8] = "CAPTURED";
    /** AUTHORIZATION_FAILED - Payment authorization failed. */
    PaymentState[PaymentState["AUTHORIZATION_FAILED"] = 9] = "AUTHORIZATION_FAILED";
    /** CAPTURE_FAILED - Payment capture failed. */
    PaymentState[PaymentState["CAPTURE_FAILED"] = 10] = "CAPTURE_FAILED";
    PaymentState[PaymentState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PaymentState = exports.PaymentState || (exports.PaymentState = {}));
function paymentStateFromJSON(object) {
    switch (object) {
        case 0:
        case "PAYMENT_STATE_UNKNOWN":
            return PaymentState.PAYMENT_STATE_UNKNOWN;
        case 1:
        case "PRESENTED":
            return PaymentState.PRESENTED;
        case 2:
        case "AUTHORIZING":
            return PaymentState.AUTHORIZING;
        case 3:
        case "AUTHORIZED":
            return PaymentState.AUTHORIZED;
        case 4:
        case "EXPIRED":
            return PaymentState.EXPIRED;
        case 5:
        case "CANCELLED":
            return PaymentState.CANCELLED;
        case 6:
        case "PENDING_CAPTURE":
            return PaymentState.PENDING_CAPTURE;
        case 7:
        case "CAPTURING":
            return PaymentState.CAPTURING;
        case 8:
        case "CAPTURED":
            return PaymentState.CAPTURED;
        case 9:
        case "AUTHORIZATION_FAILED":
            return PaymentState.AUTHORIZATION_FAILED;
        case 10:
        case "CAPTURE_FAILED":
            return PaymentState.CAPTURE_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PaymentState.UNRECOGNIZED;
    }
}
exports.paymentStateFromJSON = paymentStateFromJSON;
function paymentStateToJSON(object) {
    switch (object) {
        case PaymentState.PAYMENT_STATE_UNKNOWN:
            return "PAYMENT_STATE_UNKNOWN";
        case PaymentState.PRESENTED:
            return "PRESENTED";
        case PaymentState.AUTHORIZING:
            return "AUTHORIZING";
        case PaymentState.AUTHORIZED:
            return "AUTHORIZED";
        case PaymentState.EXPIRED:
            return "EXPIRED";
        case PaymentState.CANCELLED:
            return "CANCELLED";
        case PaymentState.PENDING_CAPTURE:
            return "PENDING_CAPTURE";
        case PaymentState.CAPTURING:
            return "CAPTURING";
        case PaymentState.CAPTURED:
            return "CAPTURED";
        case PaymentState.AUTHORIZATION_FAILED:
            return "AUTHORIZATION_FAILED";
        case PaymentState.CAPTURE_FAILED:
            return "CAPTURE_FAILED";
        case PaymentState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.paymentStateToJSON = paymentStateToJSON;
/** Categories of faults that can occur with a charger. */
var ChargerFaultCategory;
(function (ChargerFaultCategory) {
    ChargerFaultCategory[ChargerFaultCategory["CHARGER_FAULT_CATEGORY_UNKNOWN"] = 0] = "CHARGER_FAULT_CATEGORY_UNKNOWN";
    /** SOFTWARE_FAULT - Fault related to software issues. */
    ChargerFaultCategory[ChargerFaultCategory["SOFTWARE_FAULT"] = 1] = "SOFTWARE_FAULT";
    /** CHARGER_FAULT - Hardware fault with the charger itself. */
    ChargerFaultCategory[ChargerFaultCategory["CHARGER_FAULT"] = 2] = "CHARGER_FAULT";
    /** DRIVER_INDUCED_FAULT - Fault caused by driver actions or behavior. */
    ChargerFaultCategory[ChargerFaultCategory["DRIVER_INDUCED_FAULT"] = 3] = "DRIVER_INDUCED_FAULT";
    ChargerFaultCategory[ChargerFaultCategory["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ChargerFaultCategory = exports.ChargerFaultCategory || (exports.ChargerFaultCategory = {}));
function chargerFaultCategoryFromJSON(object) {
    switch (object) {
        case 0:
        case "CHARGER_FAULT_CATEGORY_UNKNOWN":
            return ChargerFaultCategory.CHARGER_FAULT_CATEGORY_UNKNOWN;
        case 1:
        case "SOFTWARE_FAULT":
            return ChargerFaultCategory.SOFTWARE_FAULT;
        case 2:
        case "CHARGER_FAULT":
            return ChargerFaultCategory.CHARGER_FAULT;
        case 3:
        case "DRIVER_INDUCED_FAULT":
            return ChargerFaultCategory.DRIVER_INDUCED_FAULT;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ChargerFaultCategory.UNRECOGNIZED;
    }
}
exports.chargerFaultCategoryFromJSON = chargerFaultCategoryFromJSON;
function chargerFaultCategoryToJSON(object) {
    switch (object) {
        case ChargerFaultCategory.CHARGER_FAULT_CATEGORY_UNKNOWN:
            return "CHARGER_FAULT_CATEGORY_UNKNOWN";
        case ChargerFaultCategory.SOFTWARE_FAULT:
            return "SOFTWARE_FAULT";
        case ChargerFaultCategory.CHARGER_FAULT:
            return "CHARGER_FAULT";
        case ChargerFaultCategory.DRIVER_INDUCED_FAULT:
            return "DRIVER_INDUCED_FAULT";
        case ChargerFaultCategory.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.chargerFaultCategoryToJSON = chargerFaultCategoryToJSON;
/** Reasons why a charger derated power during a charging session. */
var PowerQualityIssue;
(function (PowerQualityIssue) {
    /** POWER_QUALITY_ISSUE_UNKNOWN - Unknown power quality issue (protobuf default, not used by charger firmware). */
    PowerQualityIssue[PowerQualityIssue["POWER_QUALITY_ISSUE_UNKNOWN"] = 0] = "POWER_QUALITY_ISSUE_UNKNOWN";
    /** NONE - No power quality issue. */
    PowerQualityIssue[PowerQualityIssue["NONE"] = 1] = "NONE";
    /** UNSPECIFIED - Derating is active but the specific reason is unknown. */
    PowerQualityIssue[PowerQualityIssue["UNSPECIFIED"] = 2] = "UNSPECIFIED";
    /** COUPLER_OVERTEMP - Coupler temperature is too high, causing derating. */
    PowerQualityIssue[PowerQualityIssue["COUPLER_OVERTEMP"] = 3] = "COUPLER_OVERTEMP";
    /** COUPLER_TEMP_SENSOR_ERROR - Coupler temperature sensor abnormality detected. */
    PowerQualityIssue[PowerQualityIssue["COUPLER_TEMP_SENSOR_ERROR"] = 4] = "COUPLER_TEMP_SENSOR_ERROR";
    /** COOLANT_SHORTAGE - Coolant level is low (shortage or shortage warning). */
    PowerQualityIssue[PowerQualityIssue["COOLANT_SHORTAGE"] = 5] = "COOLANT_SHORTAGE";
    /** TANK_ISSUE - Coolant tank abnormality. */
    PowerQualityIssue[PowerQualityIssue["TANK_ISSUE"] = 6] = "TANK_ISSUE";
    /** HEATER_ISSUE - Chiller heater alarm. */
    PowerQualityIssue[PowerQualityIssue["HEATER_ISSUE"] = 7] = "HEATER_ISSUE";
    /** HIGH_PRESSURE - Chiller high pressure alarm. */
    PowerQualityIssue[PowerQualityIssue["HIGH_PRESSURE"] = 8] = "HIGH_PRESSURE";
    /** PUMP_ISSUE - Pump abnormality alarm. */
    PowerQualityIssue[PowerQualityIssue["PUMP_ISSUE"] = 9] = "PUMP_ISSUE";
    /** FAN_ISSUE - Fan abnormality alarm (fan 1, 2, or 3). */
    PowerQualityIssue[PowerQualityIssue["FAN_ISSUE"] = 10] = "FAN_ISSUE";
    /** LOW_PRESSURE - Chiller low pressure alarm. */
    PowerQualityIssue[PowerQualityIssue["LOW_PRESSURE"] = 11] = "LOW_PRESSURE";
    /** PRESSURE_SENSOR_ISSUE - Pressure sensor abnormality alarm. */
    PowerQualityIssue[PowerQualityIssue["PRESSURE_SENSOR_ISSUE"] = 12] = "PRESSURE_SENSOR_ISSUE";
    /** OUTLET_TEMP_SENSOR_ERROR - Outlet temperature sensor abnormality alarm. */
    PowerQualityIssue[PowerQualityIssue["OUTLET_TEMP_SENSOR_ERROR"] = 13] = "OUTLET_TEMP_SENSOR_ERROR";
    /** HEX_TEMP_SENSOR_ERROR - Heat exchanger outlet temperature sensor abnormality alarm. */
    PowerQualityIssue[PowerQualityIssue["HEX_TEMP_SENSOR_ERROR"] = 14] = "HEX_TEMP_SENSOR_ERROR";
    PowerQualityIssue[PowerQualityIssue["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PowerQualityIssue = exports.PowerQualityIssue || (exports.PowerQualityIssue = {}));
function powerQualityIssueFromJSON(object) {
    switch (object) {
        case 0:
        case "POWER_QUALITY_ISSUE_UNKNOWN":
            return PowerQualityIssue.POWER_QUALITY_ISSUE_UNKNOWN;
        case 1:
        case "NONE":
            return PowerQualityIssue.NONE;
        case 2:
        case "UNSPECIFIED":
            return PowerQualityIssue.UNSPECIFIED;
        case 3:
        case "COUPLER_OVERTEMP":
            return PowerQualityIssue.COUPLER_OVERTEMP;
        case 4:
        case "COUPLER_TEMP_SENSOR_ERROR":
            return PowerQualityIssue.COUPLER_TEMP_SENSOR_ERROR;
        case 5:
        case "COOLANT_SHORTAGE":
            return PowerQualityIssue.COOLANT_SHORTAGE;
        case 6:
        case "TANK_ISSUE":
            return PowerQualityIssue.TANK_ISSUE;
        case 7:
        case "HEATER_ISSUE":
            return PowerQualityIssue.HEATER_ISSUE;
        case 8:
        case "HIGH_PRESSURE":
            return PowerQualityIssue.HIGH_PRESSURE;
        case 9:
        case "PUMP_ISSUE":
            return PowerQualityIssue.PUMP_ISSUE;
        case 10:
        case "FAN_ISSUE":
            return PowerQualityIssue.FAN_ISSUE;
        case 11:
        case "LOW_PRESSURE":
            return PowerQualityIssue.LOW_PRESSURE;
        case 12:
        case "PRESSURE_SENSOR_ISSUE":
            return PowerQualityIssue.PRESSURE_SENSOR_ISSUE;
        case 13:
        case "OUTLET_TEMP_SENSOR_ERROR":
            return PowerQualityIssue.OUTLET_TEMP_SENSOR_ERROR;
        case 14:
        case "HEX_TEMP_SENSOR_ERROR":
            return PowerQualityIssue.HEX_TEMP_SENSOR_ERROR;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PowerQualityIssue.UNRECOGNIZED;
    }
}
exports.powerQualityIssueFromJSON = powerQualityIssueFromJSON;
function powerQualityIssueToJSON(object) {
    switch (object) {
        case PowerQualityIssue.POWER_QUALITY_ISSUE_UNKNOWN:
            return "POWER_QUALITY_ISSUE_UNKNOWN";
        case PowerQualityIssue.NONE:
            return "NONE";
        case PowerQualityIssue.UNSPECIFIED:
            return "UNSPECIFIED";
        case PowerQualityIssue.COUPLER_OVERTEMP:
            return "COUPLER_OVERTEMP";
        case PowerQualityIssue.COUPLER_TEMP_SENSOR_ERROR:
            return "COUPLER_TEMP_SENSOR_ERROR";
        case PowerQualityIssue.COOLANT_SHORTAGE:
            return "COOLANT_SHORTAGE";
        case PowerQualityIssue.TANK_ISSUE:
            return "TANK_ISSUE";
        case PowerQualityIssue.HEATER_ISSUE:
            return "HEATER_ISSUE";
        case PowerQualityIssue.HIGH_PRESSURE:
            return "HIGH_PRESSURE";
        case PowerQualityIssue.PUMP_ISSUE:
            return "PUMP_ISSUE";
        case PowerQualityIssue.FAN_ISSUE:
            return "FAN_ISSUE";
        case PowerQualityIssue.LOW_PRESSURE:
            return "LOW_PRESSURE";
        case PowerQualityIssue.PRESSURE_SENSOR_ISSUE:
            return "PRESSURE_SENSOR_ISSUE";
        case PowerQualityIssue.OUTLET_TEMP_SENSOR_ERROR:
            return "OUTLET_TEMP_SENSOR_ERROR";
        case PowerQualityIssue.HEX_TEMP_SENSOR_ERROR:
            return "HEX_TEMP_SENSOR_ERROR";
        case PowerQualityIssue.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.powerQualityIssueToJSON = powerQualityIssueToJSON;
/** Methods by which payment can be presented to a payment terminal. */
var PaymentTerminalControlPaymentPresentedMethod;
(function (PaymentTerminalControlPaymentPresentedMethod) {
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN"] = 0] = "PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN";
    /** MSR - Magnetic stripe read. */
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["MSR"] = 1] = "MSR";
    /** EMV - Europay, Mastercard, Visa (chip). */
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["EMV"] = 2] = "EMV";
    /** CTLS - Contactless. */
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["CTLS"] = 3] = "CTLS";
    /** CTLS_MSD - Contactless - magnetic stripe data emulation. */
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["CTLS_MSD"] = 4] = "CTLS_MSD";
    PaymentTerminalControlPaymentPresentedMethod[PaymentTerminalControlPaymentPresentedMethod["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(PaymentTerminalControlPaymentPresentedMethod = exports.PaymentTerminalControlPaymentPresentedMethod || (exports.PaymentTerminalControlPaymentPresentedMethod = {}));
function paymentTerminalControlPaymentPresentedMethodFromJSON(object) {
    switch (object) {
        case 0:
        case "PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN":
            return PaymentTerminalControlPaymentPresentedMethod.PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN;
        case 1:
        case "MSR":
            return PaymentTerminalControlPaymentPresentedMethod.MSR;
        case 2:
        case "EMV":
            return PaymentTerminalControlPaymentPresentedMethod.EMV;
        case 3:
        case "CTLS":
            return PaymentTerminalControlPaymentPresentedMethod.CTLS;
        case 4:
        case "CTLS_MSD":
            return PaymentTerminalControlPaymentPresentedMethod.CTLS_MSD;
        case -1:
        case "UNRECOGNIZED":
        default:
            return PaymentTerminalControlPaymentPresentedMethod.UNRECOGNIZED;
    }
}
exports.paymentTerminalControlPaymentPresentedMethodFromJSON = paymentTerminalControlPaymentPresentedMethodFromJSON;
function paymentTerminalControlPaymentPresentedMethodToJSON(object) {
    switch (object) {
        case PaymentTerminalControlPaymentPresentedMethod.PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN:
            return "PAYMENT_TERMINAL_CONTROL_PAYMENT_PRESENTED_METHOD_UNKNOWN";
        case PaymentTerminalControlPaymentPresentedMethod.MSR:
            return "MSR";
        case PaymentTerminalControlPaymentPresentedMethod.EMV:
            return "EMV";
        case PaymentTerminalControlPaymentPresentedMethod.CTLS:
            return "CTLS";
        case PaymentTerminalControlPaymentPresentedMethod.CTLS_MSD:
            return "CTLS_MSD";
        case PaymentTerminalControlPaymentPresentedMethod.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.paymentTerminalControlPaymentPresentedMethodToJSON = paymentTerminalControlPaymentPresentedMethodToJSON;
function createBaseChargingTransaction() {
    return {
        id: "",
        lastKnownState: 0,
        chargerOcppId: "",
        chargerModel: "",
        portId: 0,
        chargerFwVersion: undefined,
        chargerSwVersion: undefined,
        powerNodeSwVersion: undefined,
        errorCode: undefined,
        faultCategory: undefined,
        plugInStartUtc: undefined,
        plugInStopUtc: undefined,
        chargingTransactionStartUtc: undefined,
        chargingTransactionEndUtc: undefined,
        chargeCompletedSuccessfully: undefined,
        startTotalizerKwh: undefined,
        endTotalizerKwh: undefined,
        consumedEnergyKwh: undefined,
        peakPowerKw: undefined,
        timePowerLimited: undefined,
        estimatedAmount: undefined,
        precision: undefined,
        idleTimeStartUtc: undefined,
        idleTimeEndUtc: undefined,
        evccId: undefined,
        lastUpdatedTimestamp: undefined,
        finishCode: undefined,
        powerQualityIssues: [],
        ocppCsmsIdToken: undefined,
        ocppCsmsIdTokenType: undefined,
    };
}
exports.ChargingTransaction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.lastKnownState !== 0) {
            writer.uint32(16).int32(message.lastKnownState);
        }
        if (message.chargerOcppId !== "") {
            writer.uint32(26).string(message.chargerOcppId);
        }
        if (message.chargerModel !== "") {
            writer.uint32(34).string(message.chargerModel);
        }
        if (message.portId !== 0) {
            writer.uint32(40).int32(message.portId);
        }
        if (message.chargerFwVersion !== undefined) {
            writer.uint32(50).string(message.chargerFwVersion);
        }
        if (message.chargerSwVersion !== undefined) {
            writer.uint32(58).string(message.chargerSwVersion);
        }
        if (message.powerNodeSwVersion !== undefined) {
            writer.uint32(66).string(message.powerNodeSwVersion);
        }
        if (message.errorCode !== undefined) {
            writer.uint32(74).string(message.errorCode);
        }
        if (message.faultCategory !== undefined) {
            writer.uint32(80).int32(message.faultCategory);
        }
        if (message.plugInStartUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.plugInStartUtc), writer.uint32(90).fork()).join();
        }
        if (message.plugInStopUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.plugInStopUtc), writer.uint32(98).fork()).join();
        }
        if (message.chargingTransactionStartUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingTransactionStartUtc), writer.uint32(106).fork()).join();
        }
        if (message.chargingTransactionEndUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.chargingTransactionEndUtc), writer.uint32(114).fork()).join();
        }
        if (message.chargeCompletedSuccessfully !== undefined) {
            writer.uint32(120).bool(message.chargeCompletedSuccessfully);
        }
        if (message.startTotalizerKwh !== undefined) {
            writer.uint32(129).double(message.startTotalizerKwh);
        }
        if (message.endTotalizerKwh !== undefined) {
            writer.uint32(137).double(message.endTotalizerKwh);
        }
        if (message.consumedEnergyKwh !== undefined) {
            writer.uint32(145).double(message.consumedEnergyKwh);
        }
        if (message.peakPowerKw !== undefined) {
            writer.uint32(153).double(message.peakPowerKw);
        }
        if (message.timePowerLimited !== undefined) {
            duration_1.Duration.encode(message.timePowerLimited, writer.uint32(226).fork()).join();
        }
        if (message.estimatedAmount !== undefined) {
            writer.uint32(160).int32(message.estimatedAmount);
        }
        if (message.precision !== undefined) {
            writer.uint32(168).uint32(message.precision);
        }
        if (message.idleTimeStartUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.idleTimeStartUtc), writer.uint32(178).fork()).join();
        }
        if (message.idleTimeEndUtc !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.idleTimeEndUtc), writer.uint32(186).fork()).join();
        }
        if (message.evccId !== undefined) {
            writer.uint32(194).string(message.evccId);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(202).fork()).join();
        }
        if (message.finishCode !== undefined) {
            writer.uint32(208).uint32(message.finishCode);
        }
        writer.uint32(218).fork();
        for (const v of message.powerQualityIssues) {
            writer.int32(v);
        }
        writer.join();
        if (message.ocppCsmsIdToken !== undefined) {
            writer.uint32(234).string(message.ocppCsmsIdToken);
        }
        if (message.ocppCsmsIdTokenType !== undefined) {
            writer.uint32(242).string(message.ocppCsmsIdTokenType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargingTransaction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.lastKnownState = reader.int32();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.chargerOcppId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.chargerModel = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.portId = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.chargerFwVersion = reader.string();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.chargerSwVersion = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 66) {
                        break;
                    }
                    message.powerNodeSwVersion = reader.string();
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.errorCode = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.faultCategory = reader.int32();
                    continue;
                }
                case 11: {
                    if (tag !== 90) {
                        break;
                    }
                    message.plugInStartUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.plugInStopUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 13: {
                    if (tag !== 106) {
                        break;
                    }
                    message.chargingTransactionStartUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.chargingTransactionEndUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.chargeCompletedSuccessfully = reader.bool();
                    continue;
                }
                case 16: {
                    if (tag !== 129) {
                        break;
                    }
                    message.startTotalizerKwh = reader.double();
                    continue;
                }
                case 17: {
                    if (tag !== 137) {
                        break;
                    }
                    message.endTotalizerKwh = reader.double();
                    continue;
                }
                case 18: {
                    if (tag !== 145) {
                        break;
                    }
                    message.consumedEnergyKwh = reader.double();
                    continue;
                }
                case 19: {
                    if (tag !== 153) {
                        break;
                    }
                    message.peakPowerKw = reader.double();
                    continue;
                }
                case 28: {
                    if (tag !== 226) {
                        break;
                    }
                    message.timePowerLimited = duration_1.Duration.decode(reader, reader.uint32());
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.estimatedAmount = reader.int32();
                    continue;
                }
                case 21: {
                    if (tag !== 168) {
                        break;
                    }
                    message.precision = reader.uint32();
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.idleTimeStartUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.idleTimeEndUtc = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 24: {
                    if (tag !== 194) {
                        break;
                    }
                    message.evccId = reader.string();
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 26: {
                    if (tag !== 208) {
                        break;
                    }
                    message.finishCode = reader.uint32();
                    continue;
                }
                case 27: {
                    if (tag === 216) {
                        message.powerQualityIssues.push(reader.int32());
                        continue;
                    }
                    if (tag === 218) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.powerQualityIssues.push(reader.int32());
                        }
                        continue;
                    }
                    break;
                }
                case 29: {
                    if (tag !== 234) {
                        break;
                    }
                    message.ocppCsmsIdToken = reader.string();
                    continue;
                }
                case 30: {
                    if (tag !== 242) {
                        break;
                    }
                    message.ocppCsmsIdTokenType = reader.string();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            lastKnownState: isSet(object.lastKnownState)
                ? chargerPortStateFromJSON(object.lastKnownState)
                : isSet(object.last_known_state)
                    ? chargerPortStateFromJSON(object.last_known_state)
                    : 0,
            chargerOcppId: isSet(object.chargerOcppId)
                ? globalThis.String(object.chargerOcppId)
                : isSet(object.charger_ocpp_id)
                    ? globalThis.String(object.charger_ocpp_id)
                    : "",
            chargerModel: isSet(object.chargerModel)
                ? globalThis.String(object.chargerModel)
                : isSet(object.charger_model)
                    ? globalThis.String(object.charger_model)
                    : "",
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : 0,
            chargerFwVersion: isSet(object.chargerFwVersion)
                ? globalThis.String(object.chargerFwVersion)
                : isSet(object.charger_fw_version)
                    ? globalThis.String(object.charger_fw_version)
                    : undefined,
            chargerSwVersion: isSet(object.chargerSwVersion)
                ? globalThis.String(object.chargerSwVersion)
                : isSet(object.charger_sw_version)
                    ? globalThis.String(object.charger_sw_version)
                    : undefined,
            powerNodeSwVersion: isSet(object.powerNodeSwVersion)
                ? globalThis.String(object.powerNodeSwVersion)
                : isSet(object.power_node_sw_version)
                    ? globalThis.String(object.power_node_sw_version)
                    : undefined,
            errorCode: isSet(object.errorCode)
                ? globalThis.String(object.errorCode)
                : isSet(object.error_code)
                    ? globalThis.String(object.error_code)
                    : undefined,
            faultCategory: isSet(object.faultCategory)
                ? chargerFaultCategoryFromJSON(object.faultCategory)
                : isSet(object.fault_category)
                    ? chargerFaultCategoryFromJSON(object.fault_category)
                    : undefined,
            plugInStartUtc: isSet(object.plugInStartUtc)
                ? fromJsonTimestamp(object.plugInStartUtc)
                : isSet(object.plug_in_start_utc)
                    ? fromJsonTimestamp(object.plug_in_start_utc)
                    : undefined,
            plugInStopUtc: isSet(object.plugInStopUtc)
                ? fromJsonTimestamp(object.plugInStopUtc)
                : isSet(object.plug_in_stop_utc)
                    ? fromJsonTimestamp(object.plug_in_stop_utc)
                    : undefined,
            chargingTransactionStartUtc: isSet(object.chargingTransactionStartUtc)
                ? fromJsonTimestamp(object.chargingTransactionStartUtc)
                : isSet(object.charging_transaction_start_utc)
                    ? fromJsonTimestamp(object.charging_transaction_start_utc)
                    : undefined,
            chargingTransactionEndUtc: isSet(object.chargingTransactionEndUtc)
                ? fromJsonTimestamp(object.chargingTransactionEndUtc)
                : isSet(object.charging_transaction_end_utc)
                    ? fromJsonTimestamp(object.charging_transaction_end_utc)
                    : undefined,
            chargeCompletedSuccessfully: isSet(object.chargeCompletedSuccessfully)
                ? globalThis.Boolean(object.chargeCompletedSuccessfully)
                : isSet(object.charge_completed_successfully)
                    ? globalThis.Boolean(object.charge_completed_successfully)
                    : undefined,
            startTotalizerKwh: isSet(object.startTotalizerKwh)
                ? globalThis.Number(object.startTotalizerKwh)
                : isSet(object.start_totalizer_kwh)
                    ? globalThis.Number(object.start_totalizer_kwh)
                    : undefined,
            endTotalizerKwh: isSet(object.endTotalizerKwh)
                ? globalThis.Number(object.endTotalizerKwh)
                : isSet(object.end_totalizer_kwh)
                    ? globalThis.Number(object.end_totalizer_kwh)
                    : undefined,
            consumedEnergyKwh: isSet(object.consumedEnergyKwh)
                ? globalThis.Number(object.consumedEnergyKwh)
                : isSet(object.consumed_energy_kwh)
                    ? globalThis.Number(object.consumed_energy_kwh)
                    : undefined,
            peakPowerKw: isSet(object.peakPowerKw)
                ? globalThis.Number(object.peakPowerKw)
                : isSet(object.peak_power_kw)
                    ? globalThis.Number(object.peak_power_kw)
                    : undefined,
            timePowerLimited: isSet(object.timePowerLimited)
                ? duration_1.Duration.fromJSON(object.timePowerLimited)
                : isSet(object.time_power_limited)
                    ? duration_1.Duration.fromJSON(object.time_power_limited)
                    : undefined,
            estimatedAmount: isSet(object.estimatedAmount)
                ? globalThis.Number(object.estimatedAmount)
                : isSet(object.estimated_amount)
                    ? globalThis.Number(object.estimated_amount)
                    : undefined,
            precision: isSet(object.precision)
                ? globalThis.Number(object.precision)
                : undefined,
            idleTimeStartUtc: isSet(object.idleTimeStartUtc)
                ? fromJsonTimestamp(object.idleTimeStartUtc)
                : isSet(object.idle_time_start_utc)
                    ? fromJsonTimestamp(object.idle_time_start_utc)
                    : undefined,
            idleTimeEndUtc: isSet(object.idleTimeEndUtc)
                ? fromJsonTimestamp(object.idleTimeEndUtc)
                : isSet(object.idle_time_end_utc)
                    ? fromJsonTimestamp(object.idle_time_end_utc)
                    : undefined,
            evccId: isSet(object.evccId)
                ? globalThis.String(object.evccId)
                : isSet(object.evcc_id)
                    ? globalThis.String(object.evcc_id)
                    : undefined,
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
            finishCode: isSet(object.finishCode)
                ? globalThis.Number(object.finishCode)
                : isSet(object.finish_code)
                    ? globalThis.Number(object.finish_code)
                    : undefined,
            powerQualityIssues: globalThis.Array.isArray(object?.powerQualityIssues)
                ? object.powerQualityIssues.map((e) => powerQualityIssueFromJSON(e))
                : globalThis.Array.isArray(object?.power_quality_issues)
                    ? object.power_quality_issues.map((e) => powerQualityIssueFromJSON(e))
                    : [],
            ocppCsmsIdToken: isSet(object.ocppCsmsIdToken)
                ? globalThis.String(object.ocppCsmsIdToken)
                : isSet(object.ocpp_csms_id_token)
                    ? globalThis.String(object.ocpp_csms_id_token)
                    : undefined,
            ocppCsmsIdTokenType: isSet(object.ocppCsmsIdTokenType)
                ? globalThis.String(object.ocppCsmsIdTokenType)
                : isSet(object.ocpp_csms_id_token_type)
                    ? globalThis.String(object.ocpp_csms_id_token_type)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.lastKnownState !== 0) {
            obj.lastKnownState = chargerPortStateToJSON(message.lastKnownState);
        }
        if (message.chargerOcppId !== "") {
            obj.chargerOcppId = message.chargerOcppId;
        }
        if (message.chargerModel !== "") {
            obj.chargerModel = message.chargerModel;
        }
        if (message.portId !== 0) {
            obj.portId = Math.round(message.portId);
        }
        if (message.chargerFwVersion !== undefined) {
            obj.chargerFwVersion = message.chargerFwVersion;
        }
        if (message.chargerSwVersion !== undefined) {
            obj.chargerSwVersion = message.chargerSwVersion;
        }
        if (message.powerNodeSwVersion !== undefined) {
            obj.powerNodeSwVersion = message.powerNodeSwVersion;
        }
        if (message.errorCode !== undefined) {
            obj.errorCode = message.errorCode;
        }
        if (message.faultCategory !== undefined) {
            obj.faultCategory = chargerFaultCategoryToJSON(message.faultCategory);
        }
        if (message.plugInStartUtc !== undefined) {
            obj.plugInStartUtc = message.plugInStartUtc.toISOString();
        }
        if (message.plugInStopUtc !== undefined) {
            obj.plugInStopUtc = message.plugInStopUtc.toISOString();
        }
        if (message.chargingTransactionStartUtc !== undefined) {
            obj.chargingTransactionStartUtc =
                message.chargingTransactionStartUtc.toISOString();
        }
        if (message.chargingTransactionEndUtc !== undefined) {
            obj.chargingTransactionEndUtc =
                message.chargingTransactionEndUtc.toISOString();
        }
        if (message.chargeCompletedSuccessfully !== undefined) {
            obj.chargeCompletedSuccessfully = message.chargeCompletedSuccessfully;
        }
        if (message.startTotalizerKwh !== undefined) {
            obj.startTotalizerKwh = message.startTotalizerKwh;
        }
        if (message.endTotalizerKwh !== undefined) {
            obj.endTotalizerKwh = message.endTotalizerKwh;
        }
        if (message.consumedEnergyKwh !== undefined) {
            obj.consumedEnergyKwh = message.consumedEnergyKwh;
        }
        if (message.peakPowerKw !== undefined) {
            obj.peakPowerKw = message.peakPowerKw;
        }
        if (message.timePowerLimited !== undefined) {
            obj.timePowerLimited = duration_1.Duration.toJSON(message.timePowerLimited);
        }
        if (message.estimatedAmount !== undefined) {
            obj.estimatedAmount = Math.round(message.estimatedAmount);
        }
        if (message.precision !== undefined) {
            obj.precision = Math.round(message.precision);
        }
        if (message.idleTimeStartUtc !== undefined) {
            obj.idleTimeStartUtc = message.idleTimeStartUtc.toISOString();
        }
        if (message.idleTimeEndUtc !== undefined) {
            obj.idleTimeEndUtc = message.idleTimeEndUtc.toISOString();
        }
        if (message.evccId !== undefined) {
            obj.evccId = message.evccId;
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        if (message.finishCode !== undefined) {
            obj.finishCode = Math.round(message.finishCode);
        }
        if (message.powerQualityIssues?.length) {
            obj.powerQualityIssues = message.powerQualityIssues.map((e) => powerQualityIssueToJSON(e));
        }
        if (message.ocppCsmsIdToken !== undefined) {
            obj.ocppCsmsIdToken = message.ocppCsmsIdToken;
        }
        if (message.ocppCsmsIdTokenType !== undefined) {
            obj.ocppCsmsIdTokenType = message.ocppCsmsIdTokenType;
        }
        return obj;
    },
    create(base) {
        return exports.ChargingTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargingTransaction();
        message.id = object.id ?? "";
        message.lastKnownState = object.lastKnownState ?? 0;
        message.chargerOcppId = object.chargerOcppId ?? "";
        message.chargerModel = object.chargerModel ?? "";
        message.portId = object.portId ?? 0;
        message.chargerFwVersion = object.chargerFwVersion ?? undefined;
        message.chargerSwVersion = object.chargerSwVersion ?? undefined;
        message.powerNodeSwVersion = object.powerNodeSwVersion ?? undefined;
        message.errorCode = object.errorCode ?? undefined;
        message.faultCategory = object.faultCategory ?? undefined;
        message.plugInStartUtc = object.plugInStartUtc ?? undefined;
        message.plugInStopUtc = object.plugInStopUtc ?? undefined;
        message.chargingTransactionStartUtc =
            object.chargingTransactionStartUtc ?? undefined;
        message.chargingTransactionEndUtc =
            object.chargingTransactionEndUtc ?? undefined;
        message.chargeCompletedSuccessfully =
            object.chargeCompletedSuccessfully ?? undefined;
        message.startTotalizerKwh = object.startTotalizerKwh ?? undefined;
        message.endTotalizerKwh = object.endTotalizerKwh ?? undefined;
        message.consumedEnergyKwh = object.consumedEnergyKwh ?? undefined;
        message.peakPowerKw = object.peakPowerKw ?? undefined;
        message.timePowerLimited =
            object.timePowerLimited !== undefined && object.timePowerLimited !== null
                ? duration_1.Duration.fromPartial(object.timePowerLimited)
                : undefined;
        message.estimatedAmount = object.estimatedAmount ?? undefined;
        message.precision = object.precision ?? undefined;
        message.idleTimeStartUtc = object.idleTimeStartUtc ?? undefined;
        message.idleTimeEndUtc = object.idleTimeEndUtc ?? undefined;
        message.evccId = object.evccId ?? undefined;
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        message.finishCode = object.finishCode ?? undefined;
        message.powerQualityIssues = object.powerQualityIssues?.map((e) => e) || [];
        message.ocppCsmsIdToken = object.ocppCsmsIdToken ?? undefined;
        message.ocppCsmsIdTokenType = object.ocppCsmsIdTokenType ?? undefined;
        return message;
    },
};
function createBaseChargingTransactionDetails() {
    return {
        chargingTransactionId: "",
        chargingDetailsJson: "",
        lowRateChargingDetailsJson: "",
        lastUpdatedTimestamp: undefined,
    };
}
exports.ChargingTransactionDetails = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.chargingTransactionId !== "") {
            writer.uint32(10).string(message.chargingTransactionId);
        }
        if (message.chargingDetailsJson !== "") {
            writer.uint32(18).string(message.chargingDetailsJson);
        }
        if (message.lowRateChargingDetailsJson !== "") {
            writer.uint32(26).string(message.lowRateChargingDetailsJson);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(202).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargingTransactionDetails();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.chargingTransactionId = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.chargingDetailsJson = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.lowRateChargingDetailsJson = reader.string();
                    continue;
                }
                case 25: {
                    if (tag !== 202) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            chargingTransactionId: isSet(object.chargingTransactionId)
                ? globalThis.String(object.chargingTransactionId)
                : isSet(object.charging_transaction_id)
                    ? globalThis.String(object.charging_transaction_id)
                    : "",
            chargingDetailsJson: isSet(object.chargingDetailsJson)
                ? globalThis.String(object.chargingDetailsJson)
                : isSet(object.charging_details_json)
                    ? globalThis.String(object.charging_details_json)
                    : "",
            lowRateChargingDetailsJson: isSet(object.lowRateChargingDetailsJson)
                ? globalThis.String(object.lowRateChargingDetailsJson)
                : isSet(object.low_rate_charging_details_json)
                    ? globalThis.String(object.low_rate_charging_details_json)
                    : "",
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.chargingTransactionId !== "") {
            obj.chargingTransactionId = message.chargingTransactionId;
        }
        if (message.chargingDetailsJson !== "") {
            obj.chargingDetailsJson = message.chargingDetailsJson;
        }
        if (message.lowRateChargingDetailsJson !== "") {
            obj.lowRateChargingDetailsJson = message.lowRateChargingDetailsJson;
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.ChargingTransactionDetails.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargingTransactionDetails();
        message.chargingTransactionId = object.chargingTransactionId ?? "";
        message.chargingDetailsJson = object.chargingDetailsJson ?? "";
        message.lowRateChargingDetailsJson =
            object.lowRateChargingDetailsJson ?? "";
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        return message;
    },
};
function createBasePaymentTransaction() {
    return {
        id: "",
        paymentPresentedTimestamp: undefined,
        paymentToken: undefined,
        uniqueReference: undefined,
        lastKnownState: 0,
        portId: undefined,
        ocpiTrackingId: undefined,
        authorizationType: undefined,
        errorCode: undefined,
        authorizationSuccess: undefined,
        captureSuccess: undefined,
        maxAuthorizedAmount: undefined,
        freeReason: undefined,
        expiryTime: undefined,
        pricingModel: undefined,
        chargeBreakdown: undefined,
        providerReceiptJson: undefined,
        authorizationStatus: undefined,
        finalAmount: undefined,
        precision: undefined,
        lastUpdatedTimestamp: undefined,
        paymentTerminalId: undefined,
        resolvedPricingModel: undefined,
        savingsAmount: undefined,
    };
}
exports.PaymentTransaction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.paymentPresentedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.paymentPresentedTimestamp), writer.uint32(18).fork()).join();
        }
        if (message.paymentToken !== undefined) {
            writer.uint32(26).string(message.paymentToken);
        }
        if (message.uniqueReference !== undefined) {
            writer.uint32(34).string(message.uniqueReference);
        }
        if (message.lastKnownState !== 0) {
            writer.uint32(40).int32(message.lastKnownState);
        }
        if (message.portId !== undefined) {
            writer.uint32(48).int32(message.portId);
        }
        if (message.ocpiTrackingId !== undefined) {
            writer.uint32(58).string(message.ocpiTrackingId);
        }
        if (message.authorizationType !== undefined) {
            writer.uint32(64).int32(message.authorizationType);
        }
        if (message.errorCode !== undefined) {
            writer.uint32(72).int32(message.errorCode);
        }
        if (message.authorizationSuccess !== undefined) {
            writer.uint32(80).bool(message.authorizationSuccess);
        }
        if (message.captureSuccess !== undefined) {
            writer.uint32(88).bool(message.captureSuccess);
        }
        if (message.maxAuthorizedAmount !== undefined) {
            money_1.Money.encode(message.maxAuthorizedAmount, writer.uint32(98).fork()).join();
        }
        if (message.freeReason !== undefined) {
            writer.uint32(104).int32(message.freeReason);
        }
        if (message.expiryTime !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expiryTime), writer.uint32(114).fork()).join();
        }
        if (message.pricingModel !== undefined) {
            money_1.PricingModel.encode(message.pricingModel, writer.uint32(122).fork()).join();
        }
        if (message.chargeBreakdown !== undefined) {
            money_1.ChargeBreakdown.encode(message.chargeBreakdown, writer.uint32(130).fork()).join();
        }
        if (message.providerReceiptJson !== undefined) {
            writer.uint32(138).string(message.providerReceiptJson);
        }
        if (message.authorizationStatus !== undefined) {
            writer.uint32(144).int32(message.authorizationStatus);
        }
        if (message.finalAmount !== undefined) {
            writer.uint32(152).int32(message.finalAmount);
        }
        if (message.precision !== undefined) {
            writer.uint32(160).uint32(message.precision);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(170).fork()).join();
        }
        if (message.paymentTerminalId !== undefined) {
            writer.uint32(178).string(message.paymentTerminalId);
        }
        if (message.resolvedPricingModel !== undefined) {
            money_1.PricingModel.encode(message.resolvedPricingModel, writer.uint32(186).fork()).join();
        }
        if (message.savingsAmount !== undefined) {
            writer.uint32(192).int32(message.savingsAmount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePaymentTransaction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.paymentPresentedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.uniqueReference = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.lastKnownState = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.portId = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.ocpiTrackingId = reader.string();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.authorizationType = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.errorCode = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.authorizationSuccess = reader.bool();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.captureSuccess = reader.bool();
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.maxAuthorizedAmount = money_1.Money.decode(reader, reader.uint32());
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.freeReason = reader.int32();
                    continue;
                }
                case 14: {
                    if (tag !== 114) {
                        break;
                    }
                    message.expiryTime = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 15: {
                    if (tag !== 122) {
                        break;
                    }
                    message.pricingModel = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 16: {
                    if (tag !== 130) {
                        break;
                    }
                    message.chargeBreakdown = money_1.ChargeBreakdown.decode(reader, reader.uint32());
                    continue;
                }
                case 17: {
                    if (tag !== 138) {
                        break;
                    }
                    message.providerReceiptJson = reader.string();
                    continue;
                }
                case 18: {
                    if (tag !== 144) {
                        break;
                    }
                    message.authorizationStatus = reader.int32();
                    continue;
                }
                case 19: {
                    if (tag !== 152) {
                        break;
                    }
                    message.finalAmount = reader.int32();
                    continue;
                }
                case 20: {
                    if (tag !== 160) {
                        break;
                    }
                    message.precision = reader.uint32();
                    continue;
                }
                case 21: {
                    if (tag !== 170) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 22: {
                    if (tag !== 178) {
                        break;
                    }
                    message.paymentTerminalId = reader.string();
                    continue;
                }
                case 23: {
                    if (tag !== 186) {
                        break;
                    }
                    message.resolvedPricingModel = money_1.PricingModel.decode(reader, reader.uint32());
                    continue;
                }
                case 24: {
                    if (tag !== 192) {
                        break;
                    }
                    message.savingsAmount = reader.int32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            paymentPresentedTimestamp: isSet(object.paymentPresentedTimestamp)
                ? fromJsonTimestamp(object.paymentPresentedTimestamp)
                : isSet(object.payment_presented_timestamp)
                    ? fromJsonTimestamp(object.payment_presented_timestamp)
                    : undefined,
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : undefined,
            uniqueReference: isSet(object.uniqueReference)
                ? globalThis.String(object.uniqueReference)
                : isSet(object.unique_reference)
                    ? globalThis.String(object.unique_reference)
                    : undefined,
            lastKnownState: isSet(object.lastKnownState)
                ? paymentStateFromJSON(object.lastKnownState)
                : isSet(object.last_known_state)
                    ? paymentStateFromJSON(object.last_known_state)
                    : 0,
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : undefined,
            ocpiTrackingId: isSet(object.ocpiTrackingId)
                ? globalThis.String(object.ocpiTrackingId)
                : isSet(object.ocpi_tracking_id)
                    ? globalThis.String(object.ocpi_tracking_id)
                    : undefined,
            authorizationType: isSet(object.authorizationType)
                ? (0, money_1.paymentAuthorizationTypeFromJSON)(object.authorizationType)
                : isSet(object.authorization_type)
                    ? (0, money_1.paymentAuthorizationTypeFromJSON)(object.authorization_type)
                    : undefined,
            errorCode: isSet(object.errorCode)
                ? (0, money_1.cardPaymentErrorFromJSON)(object.errorCode)
                : isSet(object.error_code)
                    ? (0, money_1.cardPaymentErrorFromJSON)(object.error_code)
                    : undefined,
            authorizationSuccess: isSet(object.authorizationSuccess)
                ? globalThis.Boolean(object.authorizationSuccess)
                : isSet(object.authorization_success)
                    ? globalThis.Boolean(object.authorization_success)
                    : undefined,
            captureSuccess: isSet(object.captureSuccess)
                ? globalThis.Boolean(object.captureSuccess)
                : isSet(object.capture_success)
                    ? globalThis.Boolean(object.capture_success)
                    : undefined,
            maxAuthorizedAmount: isSet(object.maxAuthorizedAmount)
                ? money_1.Money.fromJSON(object.maxAuthorizedAmount)
                : isSet(object.max_authorized_amount)
                    ? money_1.Money.fromJSON(object.max_authorized_amount)
                    : undefined,
            freeReason: isSet(object.freeReason)
                ? (0, money_1.freeReasonFromJSON)(object.freeReason)
                : isSet(object.free_reason)
                    ? (0, money_1.freeReasonFromJSON)(object.free_reason)
                    : undefined,
            expiryTime: isSet(object.expiryTime)
                ? fromJsonTimestamp(object.expiryTime)
                : isSet(object.expiry_time)
                    ? fromJsonTimestamp(object.expiry_time)
                    : undefined,
            pricingModel: isSet(object.pricingModel)
                ? money_1.PricingModel.fromJSON(object.pricingModel)
                : isSet(object.pricing_model)
                    ? money_1.PricingModel.fromJSON(object.pricing_model)
                    : undefined,
            chargeBreakdown: isSet(object.chargeBreakdown)
                ? money_1.ChargeBreakdown.fromJSON(object.chargeBreakdown)
                : isSet(object.charge_breakdown)
                    ? money_1.ChargeBreakdown.fromJSON(object.charge_breakdown)
                    : undefined,
            providerReceiptJson: isSet(object.providerReceiptJson)
                ? globalThis.String(object.providerReceiptJson)
                : isSet(object.provider_receipt_json)
                    ? globalThis.String(object.provider_receipt_json)
                    : undefined,
            authorizationStatus: isSet(object.authorizationStatus)
                ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorizationStatus)
                : isSet(object.authorization_status)
                    ? (0, money_1.paymentAuthorizationStatusFromJSON)(object.authorization_status)
                    : undefined,
            finalAmount: isSet(object.finalAmount)
                ? globalThis.Number(object.finalAmount)
                : isSet(object.final_amount)
                    ? globalThis.Number(object.final_amount)
                    : undefined,
            precision: isSet(object.precision)
                ? globalThis.Number(object.precision)
                : undefined,
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
            paymentTerminalId: isSet(object.paymentTerminalId)
                ? globalThis.String(object.paymentTerminalId)
                : isSet(object.payment_terminal_id)
                    ? globalThis.String(object.payment_terminal_id)
                    : undefined,
            resolvedPricingModel: isSet(object.resolvedPricingModel)
                ? money_1.PricingModel.fromJSON(object.resolvedPricingModel)
                : isSet(object.resolved_pricing_model)
                    ? money_1.PricingModel.fromJSON(object.resolved_pricing_model)
                    : undefined,
            savingsAmount: isSet(object.savingsAmount)
                ? globalThis.Number(object.savingsAmount)
                : isSet(object.savings_amount)
                    ? globalThis.Number(object.savings_amount)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.paymentPresentedTimestamp !== undefined) {
            obj.paymentPresentedTimestamp =
                message.paymentPresentedTimestamp.toISOString();
        }
        if (message.paymentToken !== undefined) {
            obj.paymentToken = message.paymentToken;
        }
        if (message.uniqueReference !== undefined) {
            obj.uniqueReference = message.uniqueReference;
        }
        if (message.lastKnownState !== 0) {
            obj.lastKnownState = paymentStateToJSON(message.lastKnownState);
        }
        if (message.portId !== undefined) {
            obj.portId = Math.round(message.portId);
        }
        if (message.ocpiTrackingId !== undefined) {
            obj.ocpiTrackingId = message.ocpiTrackingId;
        }
        if (message.authorizationType !== undefined) {
            obj.authorizationType = (0, money_1.paymentAuthorizationTypeToJSON)(message.authorizationType);
        }
        if (message.errorCode !== undefined) {
            obj.errorCode = (0, money_1.cardPaymentErrorToJSON)(message.errorCode);
        }
        if (message.authorizationSuccess !== undefined) {
            obj.authorizationSuccess = message.authorizationSuccess;
        }
        if (message.captureSuccess !== undefined) {
            obj.captureSuccess = message.captureSuccess;
        }
        if (message.maxAuthorizedAmount !== undefined) {
            obj.maxAuthorizedAmount = money_1.Money.toJSON(message.maxAuthorizedAmount);
        }
        if (message.freeReason !== undefined) {
            obj.freeReason = (0, money_1.freeReasonToJSON)(message.freeReason);
        }
        if (message.expiryTime !== undefined) {
            obj.expiryTime = message.expiryTime.toISOString();
        }
        if (message.pricingModel !== undefined) {
            obj.pricingModel = money_1.PricingModel.toJSON(message.pricingModel);
        }
        if (message.chargeBreakdown !== undefined) {
            obj.chargeBreakdown = money_1.ChargeBreakdown.toJSON(message.chargeBreakdown);
        }
        if (message.providerReceiptJson !== undefined) {
            obj.providerReceiptJson = message.providerReceiptJson;
        }
        if (message.authorizationStatus !== undefined) {
            obj.authorizationStatus = (0, money_1.paymentAuthorizationStatusToJSON)(message.authorizationStatus);
        }
        if (message.finalAmount !== undefined) {
            obj.finalAmount = Math.round(message.finalAmount);
        }
        if (message.precision !== undefined) {
            obj.precision = Math.round(message.precision);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        if (message.paymentTerminalId !== undefined) {
            obj.paymentTerminalId = message.paymentTerminalId;
        }
        if (message.resolvedPricingModel !== undefined) {
            obj.resolvedPricingModel = money_1.PricingModel.toJSON(message.resolvedPricingModel);
        }
        if (message.savingsAmount !== undefined) {
            obj.savingsAmount = Math.round(message.savingsAmount);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentTransaction();
        message.id = object.id ?? "";
        message.paymentPresentedTimestamp =
            object.paymentPresentedTimestamp ?? undefined;
        message.paymentToken = object.paymentToken ?? undefined;
        message.uniqueReference = object.uniqueReference ?? undefined;
        message.lastKnownState = object.lastKnownState ?? 0;
        message.portId = object.portId ?? undefined;
        message.ocpiTrackingId = object.ocpiTrackingId ?? undefined;
        message.authorizationType = object.authorizationType ?? undefined;
        message.errorCode = object.errorCode ?? undefined;
        message.authorizationSuccess = object.authorizationSuccess ?? undefined;
        message.captureSuccess = object.captureSuccess ?? undefined;
        message.maxAuthorizedAmount =
            object.maxAuthorizedAmount !== undefined &&
                object.maxAuthorizedAmount !== null
                ? money_1.Money.fromPartial(object.maxAuthorizedAmount)
                : undefined;
        message.freeReason = object.freeReason ?? undefined;
        message.expiryTime = object.expiryTime ?? undefined;
        message.pricingModel =
            object.pricingModel !== undefined && object.pricingModel !== null
                ? money_1.PricingModel.fromPartial(object.pricingModel)
                : undefined;
        message.chargeBreakdown =
            object.chargeBreakdown !== undefined && object.chargeBreakdown !== null
                ? money_1.ChargeBreakdown.fromPartial(object.chargeBreakdown)
                : undefined;
        message.providerReceiptJson = object.providerReceiptJson ?? undefined;
        message.authorizationStatus = object.authorizationStatus ?? undefined;
        message.finalAmount = object.finalAmount ?? undefined;
        message.precision = object.precision ?? undefined;
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        message.paymentTerminalId = object.paymentTerminalId ?? undefined;
        message.resolvedPricingModel =
            object.resolvedPricingModel !== undefined &&
                object.resolvedPricingModel !== null
                ? money_1.PricingModel.fromPartial(object.resolvedPricingModel)
                : undefined;
        message.savingsAmount = object.savingsAmount ?? undefined;
        return message;
    },
};
function createBaseMembershipTransaction() {
    return {
        id: "",
        membershipPresentedTimestamp: undefined,
        membershipToken: undefined,
        isValid: undefined,
        portId: undefined,
        success: undefined,
        lastUpdatedTimestamp: undefined,
        actionCode: undefined,
        actionId: undefined,
        tierCode: undefined,
        informProceedConfirmed: undefined,
    };
}
exports.MembershipTransaction = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.membershipPresentedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.membershipPresentedTimestamp), writer.uint32(18).fork()).join();
        }
        if (message.membershipToken !== undefined) {
            writer.uint32(26).string(message.membershipToken);
        }
        if (message.isValid !== undefined) {
            writer.uint32(32).bool(message.isValid);
        }
        if (message.portId !== undefined) {
            writer.uint32(40).int32(message.portId);
        }
        if (message.success !== undefined) {
            writer.uint32(48).bool(message.success);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(58).fork()).join();
        }
        if (message.actionCode !== undefined) {
            writer.uint32(64).int32(message.actionCode);
        }
        if (message.actionId !== undefined) {
            writer.uint32(72).int32(message.actionId);
        }
        if (message.tierCode !== undefined) {
            writer.uint32(82).string(message.tierCode);
        }
        if (message.informProceedConfirmed !== undefined) {
            writer.uint32(88).bool(message.informProceedConfirmed);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMembershipTransaction();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.membershipPresentedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.membershipToken = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.isValid = reader.bool();
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.portId = reader.int32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.success = reader.bool();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.actionCode = reader.int32();
                    continue;
                }
                case 9: {
                    if (tag !== 72) {
                        break;
                    }
                    message.actionId = reader.int32();
                    continue;
                }
                case 10: {
                    if (tag !== 82) {
                        break;
                    }
                    message.tierCode = reader.string();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.informProceedConfirmed = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            membershipPresentedTimestamp: isSet(object.membershipPresentedTimestamp)
                ? fromJsonTimestamp(object.membershipPresentedTimestamp)
                : isSet(object.membership_presented_timestamp)
                    ? fromJsonTimestamp(object.membership_presented_timestamp)
                    : undefined,
            membershipToken: isSet(object.membershipToken)
                ? globalThis.String(object.membershipToken)
                : isSet(object.membership_token)
                    ? globalThis.String(object.membership_token)
                    : undefined,
            isValid: isSet(object.isValid)
                ? globalThis.Boolean(object.isValid)
                : isSet(object.is_valid)
                    ? globalThis.Boolean(object.is_valid)
                    : undefined,
            portId: isSet(object.portId)
                ? globalThis.Number(object.portId)
                : isSet(object.port_id)
                    ? globalThis.Number(object.port_id)
                    : undefined,
            success: isSet(object.success)
                ? globalThis.Boolean(object.success)
                : undefined,
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
            actionCode: isSet(object.actionCode)
                ? membershipActionCodeFromJSON(object.actionCode)
                : isSet(object.action_code)
                    ? membershipActionCodeFromJSON(object.action_code)
                    : undefined,
            actionId: isSet(object.actionId)
                ? globalThis.Number(object.actionId)
                : isSet(object.action_id)
                    ? globalThis.Number(object.action_id)
                    : undefined,
            tierCode: isSet(object.tierCode)
                ? globalThis.String(object.tierCode)
                : isSet(object.tier_code)
                    ? globalThis.String(object.tier_code)
                    : undefined,
            informProceedConfirmed: isSet(object.informProceedConfirmed)
                ? globalThis.Boolean(object.informProceedConfirmed)
                : isSet(object.inform_proceed_confirmed)
                    ? globalThis.Boolean(object.inform_proceed_confirmed)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.membershipPresentedTimestamp !== undefined) {
            obj.membershipPresentedTimestamp =
                message.membershipPresentedTimestamp.toISOString();
        }
        if (message.membershipToken !== undefined) {
            obj.membershipToken = message.membershipToken;
        }
        if (message.isValid !== undefined) {
            obj.isValid = message.isValid;
        }
        if (message.portId !== undefined) {
            obj.portId = Math.round(message.portId);
        }
        if (message.success !== undefined) {
            obj.success = message.success;
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        if (message.actionCode !== undefined) {
            obj.actionCode = membershipActionCodeToJSON(message.actionCode);
        }
        if (message.actionId !== undefined) {
            obj.actionId = Math.round(message.actionId);
        }
        if (message.tierCode !== undefined) {
            obj.tierCode = message.tierCode;
        }
        if (message.informProceedConfirmed !== undefined) {
            obj.informProceedConfirmed = message.informProceedConfirmed;
        }
        return obj;
    },
    create(base) {
        return exports.MembershipTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseMembershipTransaction();
        message.id = object.id ?? "";
        message.membershipPresentedTimestamp =
            object.membershipPresentedTimestamp ?? undefined;
        message.membershipToken = object.membershipToken ?? undefined;
        message.isValid = object.isValid ?? undefined;
        message.portId = object.portId ?? undefined;
        message.success = object.success ?? undefined;
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        message.actionCode = object.actionCode ?? undefined;
        message.actionId = object.actionId ?? undefined;
        message.tierCode = object.tierCode ?? undefined;
        message.informProceedConfirmed = object.informProceedConfirmed ?? undefined;
        return message;
    },
};
function createBaseChargingSessionAttempt() {
    return {
        id: "",
        sessionId: "",
        paymentTransactionId: undefined,
        chargingTransactionId: undefined,
        membershipTransactionId: undefined,
        matchingPattern: undefined,
        lastUpdatedTimestamp: undefined,
        membershipValidationSkipped: undefined,
    };
}
exports.ChargingSessionAttempt = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.sessionId !== "") {
            writer.uint32(18).string(message.sessionId);
        }
        if (message.paymentTransactionId !== undefined) {
            writer.uint32(26).string(message.paymentTransactionId);
        }
        if (message.chargingTransactionId !== undefined) {
            writer.uint32(34).string(message.chargingTransactionId);
        }
        if (message.membershipTransactionId !== undefined) {
            writer.uint32(42).string(message.membershipTransactionId);
        }
        if (message.matchingPattern !== undefined) {
            writer.uint32(48).int32(message.matchingPattern);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(58).fork()).join();
        }
        if (message.membershipValidationSkipped !== undefined) {
            writer.uint32(64).bool(message.membershipValidationSkipped);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargingSessionAttempt();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.sessionId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentTransactionId = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.chargingTransactionId = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.membershipTransactionId = reader.string();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.matchingPattern = reader.int32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.membershipValidationSkipped = reader.bool();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            sessionId: isSet(object.sessionId)
                ? globalThis.String(object.sessionId)
                : isSet(object.session_id)
                    ? globalThis.String(object.session_id)
                    : "",
            paymentTransactionId: isSet(object.paymentTransactionId)
                ? globalThis.String(object.paymentTransactionId)
                : isSet(object.payment_transaction_id)
                    ? globalThis.String(object.payment_transaction_id)
                    : undefined,
            chargingTransactionId: isSet(object.chargingTransactionId)
                ? globalThis.String(object.chargingTransactionId)
                : isSet(object.charging_transaction_id)
                    ? globalThis.String(object.charging_transaction_id)
                    : undefined,
            membershipTransactionId: isSet(object.membershipTransactionId)
                ? globalThis.String(object.membershipTransactionId)
                : isSet(object.membership_transaction_id)
                    ? globalThis.String(object.membership_transaction_id)
                    : undefined,
            matchingPattern: isSet(object.matchingPattern)
                ? chargingSessionMatchingPatternFromJSON(object.matchingPattern)
                : isSet(object.matching_pattern)
                    ? chargingSessionMatchingPatternFromJSON(object.matching_pattern)
                    : undefined,
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
            membershipValidationSkipped: isSet(object.membershipValidationSkipped)
                ? globalThis.Boolean(object.membershipValidationSkipped)
                : isSet(object.membership_validation_skipped)
                    ? globalThis.Boolean(object.membership_validation_skipped)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.sessionId !== "") {
            obj.sessionId = message.sessionId;
        }
        if (message.paymentTransactionId !== undefined) {
            obj.paymentTransactionId = message.paymentTransactionId;
        }
        if (message.chargingTransactionId !== undefined) {
            obj.chargingTransactionId = message.chargingTransactionId;
        }
        if (message.membershipTransactionId !== undefined) {
            obj.membershipTransactionId = message.membershipTransactionId;
        }
        if (message.matchingPattern !== undefined) {
            obj.matchingPattern = chargingSessionMatchingPatternToJSON(message.matchingPattern);
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        if (message.membershipValidationSkipped !== undefined) {
            obj.membershipValidationSkipped = message.membershipValidationSkipped;
        }
        return obj;
    },
    create(base) {
        return exports.ChargingSessionAttempt.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargingSessionAttempt();
        message.id = object.id ?? "";
        message.sessionId = object.sessionId ?? "";
        message.paymentTransactionId = object.paymentTransactionId ?? undefined;
        message.chargingTransactionId = object.chargingTransactionId ?? undefined;
        message.membershipTransactionId =
            object.membershipTransactionId ?? undefined;
        message.matchingPattern = object.matchingPattern ?? undefined;
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        message.membershipValidationSkipped =
            object.membershipValidationSkipped ?? undefined;
        return message;
    },
};
function createBaseChargingSession() {
    return {
        id: "",
        evccId: undefined,
        paymentToken: undefined,
        membershipToken: undefined,
        firstAttemptOfCharging: undefined,
        lastUpdatedTimestamp: undefined,
    };
}
exports.ChargingSession = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        if (message.evccId !== undefined) {
            writer.uint32(18).string(message.evccId);
        }
        if (message.paymentToken !== undefined) {
            writer.uint32(26).string(message.paymentToken);
        }
        if (message.membershipToken !== undefined) {
            writer.uint32(34).string(message.membershipToken);
        }
        if (message.firstAttemptOfCharging !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.firstAttemptOfCharging), writer.uint32(42).fork()).join();
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.lastUpdatedTimestamp), writer.uint32(50).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        const end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseChargingSession();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.id = reader.string();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.evccId = reader.string();
                    continue;
                }
                case 3: {
                    if (tag !== 26) {
                        break;
                    }
                    message.paymentToken = reader.string();
                    continue;
                }
                case 4: {
                    if (tag !== 34) {
                        break;
                    }
                    message.membershipToken = reader.string();
                    continue;
                }
                case 5: {
                    if (tag !== 42) {
                        break;
                    }
                    message.firstAttemptOfCharging = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
                case 6: {
                    if (tag !== 50) {
                        break;
                    }
                    message.lastUpdatedTimestamp = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            id: isSet(object.id) ? globalThis.String(object.id) : "",
            evccId: isSet(object.evccId)
                ? globalThis.String(object.evccId)
                : isSet(object.evcc_id)
                    ? globalThis.String(object.evcc_id)
                    : undefined,
            paymentToken: isSet(object.paymentToken)
                ? globalThis.String(object.paymentToken)
                : isSet(object.payment_token)
                    ? globalThis.String(object.payment_token)
                    : undefined,
            membershipToken: isSet(object.membershipToken)
                ? globalThis.String(object.membershipToken)
                : isSet(object.membership_token)
                    ? globalThis.String(object.membership_token)
                    : undefined,
            firstAttemptOfCharging: isSet(object.firstAttemptOfCharging)
                ? fromJsonTimestamp(object.firstAttemptOfCharging)
                : isSet(object.first_attempt_of_charging)
                    ? fromJsonTimestamp(object.first_attempt_of_charging)
                    : undefined,
            lastUpdatedTimestamp: isSet(object.lastUpdatedTimestamp)
                ? fromJsonTimestamp(object.lastUpdatedTimestamp)
                : isSet(object.last_updated_timestamp)
                    ? fromJsonTimestamp(object.last_updated_timestamp)
                    : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== "") {
            obj.id = message.id;
        }
        if (message.evccId !== undefined) {
            obj.evccId = message.evccId;
        }
        if (message.paymentToken !== undefined) {
            obj.paymentToken = message.paymentToken;
        }
        if (message.membershipToken !== undefined) {
            obj.membershipToken = message.membershipToken;
        }
        if (message.firstAttemptOfCharging !== undefined) {
            obj.firstAttemptOfCharging = message.firstAttemptOfCharging.toISOString();
        }
        if (message.lastUpdatedTimestamp !== undefined) {
            obj.lastUpdatedTimestamp = message.lastUpdatedTimestamp.toISOString();
        }
        return obj;
    },
    create(base) {
        return exports.ChargingSession.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseChargingSession();
        message.id = object.id ?? "";
        message.evccId = object.evccId ?? undefined;
        message.paymentToken = object.paymentToken ?? undefined;
        message.membershipToken = object.membershipToken ?? undefined;
        message.firstAttemptOfCharging = object.firstAttemptOfCharging ?? undefined;
        message.lastUpdatedTimestamp = object.lastUpdatedTimestamp ?? undefined;
        return message;
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
function isSet(value) {
    return value !== null && value !== undefined;
}
